import React from "react";
import IsAlbum from "./IsAlbum";
import UploadAlbumMetaData from "./UploadAlbumMetaData";
import { useFormik } from "formik";
import { useSelector } from "react-redux";
import SelectAlbum from "./SelectAlbum";
import UploadMultipleSongs from "./UploadMultipleSongs";

const AlbumHandler = ({ formik }) => {
  const isAlbum = useSelector((state) => state.contentForm.isAlbum);
  const albumId = useSelector((state) => state.contentForm.albumId);

  return (
    <div>
      <IsAlbum label={"Do you want to upload album?"} />
      
      {isAlbum && (
        <>
          <SelectAlbum formik={formik} />
          {/* <UploadAlbumMetaData formik={formik} /> */}
          {/* {albumId && <UploadMultipleSongs formik={formik} />} */}
        </>
      )}
    </div>
  );
};

export default AlbumHandler;